/** API route map: URLS.Controller.TrainingManagement */
export const TrainingManagement = {
      Name: 'TrainingQuiz/',
      GetQuizzesPaginated: 'get-training-quizzes-paginated',
      AddQuiz: 'add-training-quiz',
      EditQuiz: 'update-training-quiz',
      DeleteQuiz: 'delete-training-quiz',
      GetTrainingQuiz: 'get-training-quiz',
      GetTrainingQuizUsersDropDown: 'get-training-quiz-users-drop-down',
      DeleteTrainingMaterial: 'delete-training-material',
      AddTrainingQuizQuestionnaire: 'add-questionnaire',
      DeleteTrainingQuizQuestionnaire: 'delete-questionnaire',
      EditTrainingQuizQuestionnaire: 'edit-questionnaire',
      GetTrainingQuizQuestionnaire: 'get-questionnaire',
      GetMaterials: 'get-material',
};
